import { canAccountBadgeBeEdited, canAccountBadgeBeReissued, getAccountBadgeValidDistributionStatusChanges, getAccountBadgeValidStatusChanges, requireRevokeBadgesPermissions, } from '../../../../backend/features/badges/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
/**
 * Centralized place for all Account Badge action checks
 *
 * For single Account Badge and for multiple (bulk actions)
 */
export function useAccountBadgeActionChecks({ accountBadgesSelected, }) {
    const userState = useUserState();
    const isSomeValid = accountBadgesSelected.some((ab) => ab.columns.status === 'valid');
    const accountBadgesSelectedWithInfo = accountBadgesSelected.map((ab) => {
        return {
            ab,
            validStatusChanges: getAccountBadgeValidStatusChanges(ab.columns.status),
            validDistributionStatusChanges: getAccountBadgeValidDistributionStatusChanges(ab.columns),
        };
    });
    const badgesThatCanBeRevoked = accountBadgesSelectedWithInfo.filter(({ validStatusChanges }) => validStatusChanges.includes('revoked'));
    return {
        canPrint: accountBadgesSelectedWithInfo.some(({ ab }) => canAccountBadgeBeEdited(ab)),
        canNotify: accountBadgesSelected.some((ab) => ab.columns.status === 'valid' && ab.columns.distributionStatus === 'printed'),
        canRevoke: badgesThatCanBeRevoked.length > 0 &&
            (requireRevokeBadgesPermissions(userState) || badgesThatCanBeRevoked.every(({ ab }) => ab.columns.accountId === userState.id)),
        canReissue: accountBadgesSelected.some((ab) => canAccountBadgeBeReissued(ab).canReissue),
        canEditDistributionStatus: isSomeValid,
        canEditExpirationDate: isSomeValid,
        canEditAccountBadge: accountBadgesSelected.length > 0 && accountBadgesSelected.every((ab) => canAccountBadgeBeEdited(ab)),
    };
}
